import {
  formatDistance as dateFnsformatDistance,
  format,
  differenceInHours,
  minTime,
  maxTime,
  addDays,
  getDayOfYear,
} from 'date-fns'
import { isNil } from 'lodash'
import { getDateLocale } from '../../../i18n'

const ANY_YEAR = 2021
const ANY_NON_LEAP_YEAR = 2021

export const formatDistance = (isoDate: string): string =>
  dateFnsformatDistance(new Date(isoDate), new Date(), {
    locale: getDateLocale(),
    addSuffix: true,
  })

export function formatDate(date: Date, dateFormat: string): string {
  return format(date, dateFormat, {
    locale: getDateLocale(),
  })
}

export function formatMonth(monthIndex: number, dateFormat: string): string {
  return formatDate(new Date(ANY_YEAR, monthIndex, 1), dateFormat)
}

export function getMonthStartHour(monthIndex: number): number {
  const yearStart = new Date(ANY_NON_LEAP_YEAR, 0, 1, 0)
  const monthStart = new Date(ANY_NON_LEAP_YEAR, monthIndex, 1, 0)

  return differenceInHours(monthStart, yearStart)
}

export function getMonthStartHourOfYear(
  year: number,
  monthIndex: number,
): number {
  const yearStart = new Date(year, 0, 1, 0)
  const monthStart = new Date(year, monthIndex, 1, 0)

  return differenceInHours(monthStart, yearStart)
}

export function getValuesForMonth(
  hourlyValues: number[],
  monthIndex?: number,
): number[] {
  return isNil(monthIndex)
    ? hourlyValues
    : hourlyValues.slice(
        getMonthStartHour(monthIndex),
        getMonthStartHour(monthIndex + 1),
      )
}

/** Get the ISO formatted time of the start of the local day */
export function getIsoStringAtStartOfDay(date?: Date): string | undefined {
  if (!date) {
    return date
  }
  const modifiedDate = new Date(date)
  modifiedDate.setHours(0, 0, 0, 0)
  return modifiedDate.toISOString()
}

export function getMinDate(): Date {
  return new Date(minTime)
}

export function getMaxDate(): Date {
  return new Date(maxTime)
}

export function addDaysToDate(date: Date, amount: number): Date {
  return addDays(date, amount)
}

export function getDayNumberOfYear(date: Date): number {
  return getDayOfYear(date)
}
